import { ClarityManager } from "../core/clarity.js";
import { Loader } from "../customplugins/loader.js";
import { Toaster } from "../customplugins/toaster.js";

document.addEventListener("DOMContentLoaded", () => {


    var resetdata = document.getElementById("hdnForgotPassword") as HTMLElement
    if (resetdata) {
        resetdata.style.display = "none";
    }

    const input = document.getElementById("forgotdistributor") as HTMLInputElement;
    const errorLabel = document.getElementById("lbl_forgotdistributor") as HTMLSpanElement;
    if (errorLabel) {
        errorLabel.style.display = "none";
    }

    input.addEventListener("input", () => {
        const data = input.value.trim();

        if (data === "") {

            errorLabel.style.display = "inline";
        } else {

            errorLabel.style.display = "none";
        }
    });

    input.addEventListener("input", () => {
        if (input.value.trim() !== "") {
            errorLabel.style.display = "none";
        }
    });


});

var data: any;

document.getElementById("btnforgotpassword").addEventListener("click", function () {
     data = (document.getElementById("forgotdistributor") as HTMLInputElement).value.trim();
    getforgotpassword(data);
});


function getforgotpassword(data: any): void {
    var derror = document.getElementById("lbl_forgotdistributor") as HTMLSpanElement;
    if (data == "") {

       
        if (derror) {
            derror.textContent = "User ID is Required";
            derror.style.display = "block";
        }
        return
    }
    Loader.show();
    var fomdata = new FormData();
    fomdata.append("distributorIdno", data);
    fomdata.append("tenant_id", "0");


    fetch("/ForgotedPassword", {
        method: "POST",

        body: fomdata
    })
        .then(res => res.json())
        .then((response) => {
         
            if (response.status == "Success") {
                derror.textContent = response.msg;
                derror.style.display = "block";
                (document.getElementById("forgotdistributor") as HTMLInputElement).value = "";
                Loader.hide();
                return;
            }
            else {
                Toaster.error(response.msg);

                Loader.hide();
                return;
            }

         
        });
    

}




